
const text = {
    'en-US': {
        welcome: 'Welcome, TOWA - The One Weater Assistant for you.',
        loading: 'Loading...'
        // Add more labels as needed
    },
    'zh-CN': {
        welcome: '欢迎，TOWA - 你唯一需要的天气助手',
        loading: '正在搜索...'
        // Add more labels as needed
    },
    'zh-Hant': {
        welcome: '歡迎，TOWA - 你唯一需要的天氣助手',
        loading: '正在搜索...'
        // Add more labels as needed
    },
    // Add more languages as needed
};

export default text;